<template>
  <v-card class="transparent" flat>
    <v-list class="transparent">
      <v-list-item two-line class="overline">
          <v-img
          @click="$router.push('/').catch(()=>{})"
            :src="require('@/assets/logo_st.png')"
            max-width="50"
            max-height="50"
            class="mr-2"
          />
        <v-list-item-content>
          <v-list-item-title class="text-h5">SAFETAXI</v-list-item-title>
          <v-list-item-subtitle class="text-button">servicios moviles</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
export default {
  methods: {
    to(uri) {
      this.$router.push(uri).catch((error) => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
    },
  },
};
</script>

<style>
.transparent{
  background: none !important;
}
</style>